export const CHANGE_PASSWORD = "Change Password";

export const ADS_DOMAIN = "ADS";

export const ADS_DOMAIN_PATH = "/";

export const ADS_DOMAIN_TITLE = "Change your password";

export const ADS_DOMAIN_DESCRIPTION = "For your security, all Autodesk employees must change their password every 365 days.\n" +
    "Employees with admin accounts must change their admin password every 90 days.\n" +
    "You can only change your password once every 24 hours.";

export const GO_HOME_OPTIONS = "Go Home";

export const BAD_USER = "Bad user";

export const BAD_OLD_PASSWORD = "BadOldPassword";

export const BAD_NEW_PASSWORD = "BadNewPassword";

export const BAD_USER_ERROR_TEXT = "Please enter a valid username.";

export const INTERNALSERVER_ERROR_STATUS_CODE = "500";

export const BAD_OLD_PASSWORD_ERROR_TEXT = "Your username and current password do not match.";

export const BAD_NEW_PASSWORD_ERROR_TEXT =
         "Please ensure that that you are not re-using any of your last 5 passwords and try another password with more characters.";

export const MAX_ATTEMPTS_ERROR = "MaxAttemptsError";

export const MAX_ATTEMPTS_ERROR_TEXT = "<div><strong>Unable to Change Password</strong></div>" +
    "<div>We're sorry, your password can't be changed at this time. Please wait and try again later or call the Service Desk." +
    "+1-415-507-8888 or ext <strong>78888</strong>.</div>";

export const ERROR_TEXT = "<div><strong>There was an error that wasn’t your fault. Please try again later or call the Service Desk at +1-415-507-8888 or ext 78888</strong></div>";

export const BAD_CONFIRM_PASSWORD_ERROR_TEXT = "Passwords do not match";

export const NEW_PATTERNS_WARNING_TEXT = "Passwords must be at least 14 characters long and include at least 3 of the following complexity attributes:";

export const NEW_PATTERNS_WARNING_DETAILS = "<ul><li>Uppercase characters of European languages (A through Z)</li><li>Lowercase characters of European languages (a through z)</li>" +
    "<li>Base 10 digits (0 through 9)</li><li>Non-alphanumeric characters (~!@#$%^&*_-+=`|(){}[]:;\"\"'<>,.?/)</li><li>Any Unicode character that is categorized as an alphabetic character but is not uppercase or lowercase</li></ul>" +
    "\n\nAdditionally, Autodesk passwords are evaluated against the following patterns:" +
    "<ul><li>Weak passwords (e.g., ‘Password123456!’)</li><li>Known weak passwords (e.g., ‘Changeme123456!’ or ‘Contoso!123456’)</li>" +
         "<li>Autodesk company name or product names within the password (e.g., ‘Autodesk101010!’ or ‘@ut0desk123456’)</li><li>Compromised passwords that were publicly published in a previous data breach</li></ul>";

export const FOOTER_TELL_US_URL = "https://feedback.employeehub.autodesk.com";

export const EMPLOYEE_HUB_SLACK_URL = "https://autodesk.slack.com/sso/saml/start?redir=/app_redirect?channel=C6C75BM9A";